import { clearInvestmentData } from '../../../redux/project/investmentSlice';
import HeaderSection from './sections/HeaderSection';
import InfoSection from './sections/InfoSection';
import PropertyOverViewSection from './sections/PropertyOverViewSection';
import DetailsSection from './sections/DetailsSection';
import LocationSection from './sections/LocationSection';
// import InvestmentSection from './sections/InvestmentSection';
import ImagesGallerySection from './sections/ImagesGallerySection';
import WhyInvestSection from './sections/WhyInvestSection';
import FooterAdvertisementSection from './sections/FooterAdvertisementSection';
import { Tabs, Tab } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../redux/store';

export default function InvestmentForm({
  investmentData,
  handleInputChange,
  handleAddItem,
  handleObjectArrayInputChange,
  currentTab,
  totalTabs,
  handleTabChange,
  handleNext,
  handlePrevious,
  handleSubmit,
  removeItemFromArray,
  handleNearbyLocations,
  title,
  flow,
}) {
  const dispatch: AppDispatch = useDispatch();
  return (
    <div className="container mt-5">
      <div className="d-flex justify-content-between">
        <h1 className="mb-4">{title}</h1>
        {/* Clear Project Data Button */}
        {flow == 'add' && (
          <button
            onClick={() => dispatch(clearInvestmentData())}
            className="btn btn-danger fs-5 p-3"
          >
            Clear Project Data
          </button>
        )}
      </div>
      <div className="form add_project_form">
        <Tabs
          activeKey={currentTab}
          onSelect={(k) => handleTabChange(Number(k))}
          id="project-steps-tab"
          className="mb-3"
        >
          {/* Step 1: Header Section */}
          <Tab eventKey={0} title="Header">
            <HeaderSection
              handleInputChange={handleInputChange}
              investmentData={investmentData}
            />
          </Tab>

          {/* Step 2: Info Section */}
          <Tab eventKey={1} title="Info">
            <InfoSection
              handleInputChange={handleInputChange}
              dispatch={dispatch}
              investmentData={investmentData}
              handleAddItem={handleAddItem}
              removeItemFromArray={removeItemFromArray}
            />
          </Tab>

          {/* Step 3: Property Overview Section */}
          <Tab eventKey={2} title="Overview">
            <PropertyOverViewSection
              handleInputChange={handleInputChange}
              dispatch={dispatch}
              investmentData={investmentData}
              handleAddItem={handleAddItem}
              removeItemFromArray={removeItemFromArray}
            />
          </Tab>

          {/* Step 4: Property Details Section */}
          <Tab eventKey={3} title="Details">
            <DetailsSection
              handleInputChange={handleInputChange}
              dispatch={dispatch}
              investmentData={investmentData}
              handleAddItem={handleAddItem}
              handleObjectArrayInputChange={handleObjectArrayInputChange}
              removeItemFromArray={removeItemFromArray}
            />
          </Tab>

          {/* Step 5: Investment Section */}
          {/* <Tab eventKey={4} title="Investment">
            <InvestmentSection
              investmentData={investmentData}
              dispatch={dispatch}
              handleAddItem={handleAddItem}
              handleInputChange={handleInputChange}
            />
          </Tab> */}

          {/* Step 6: Images Gallery Section */}
          <Tab eventKey={4} title="Gallery">
            <ImagesGallerySection
              investmentData={investmentData}
              dispatch={dispatch}
              handleAddItem={handleAddItem}
              handleInputChange={handleInputChange}
              removeItemFromArray={removeItemFromArray}
            />
          </Tab>

          {/* Step 7: Location Section */}
          <Tab eventKey={5} title="Location">
            <LocationSection
              investmentData={investmentData}
              dispatch={dispatch}
              handleAddItem={handleAddItem}
              handleInputChange={handleInputChange}
              removeItemFromArray={removeItemFromArray}
              handleNearbyLocations={handleNearbyLocations}
            />
          </Tab>

          {/* Step 8: Why Invest Section */}
          <Tab eventKey={6} title="Why Invest">
            <WhyInvestSection
              investmentData={investmentData}
              dispatch={dispatch}
              handleAddItem={handleAddItem}
              handleInputChange={handleInputChange}
              removeItemFromArray={removeItemFromArray}
            />
          </Tab>

          {/* Step 9: Footer Advertisement Section */}
          <Tab eventKey={7} title="Footer">
            <FooterAdvertisementSection
              investmentData={investmentData}
              handleInputChange={handleInputChange}
            />
          </Tab>
        </Tabs>
        <div className="d-flex justify-content-between mt-3">
          <button
            className={`btn ${currentTab == 0 ? 'btn-secondary' : 'btn-primary'} add_project_section_navigation`}
            onClick={handlePrevious}
            disabled={currentTab === 0}
          >
            Previous
          </button>
          <button
            className={`btn ${currentTab == totalTabs - 1 ? 'btn-secondary' : 'btn-primary'} add_project_section_navigation`}
            onClick={handleNext}
            disabled={currentTab === totalTabs - 1}
          >
            Next
          </button>
        </div>
        {/* Submit Button */}
        {currentTab === totalTabs - 1 && (
          <button
            onClick={handleSubmit}
            className="btn btn-primary mt-4 w-100 p-2"
          >
            Submit
          </button>
        )}
      </div>
    </div>
  );
}
